import axios from 'axios'
import { PurchaseProcessId } from '../store/payment/PaymentStateInterface'

export function buyMainOffer(
  pageId: number,
  purchaseProcessId: PurchaseProcessId,
  body: any,
) {
  return axios.post(
    `/secure/flutterwave/${pageId}/buy-main-offer/${purchaseProcessId}`,
    body,
  )
}

export function buyUpsellOffer(
  pageId: number,
  purchaseProcessId: number,
  body: any,
) {
  return axios.post(
    `/secure/flutterwave/${pageId}/buy-upsell/${purchaseProcessId}`,
    body,
  )
}
